import { render, staticRenderFns } from "./LoyaltyPromoCreateCommunication.vue?vue&type=template&id=bf3fd1da&scoped=true&lang=pug"
import script from "./LoyaltyPromoCreateCommunication.vue?vue&type=script&lang=ts"
export * from "./LoyaltyPromoCreateCommunication.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyPromoCreateCommunication.vue?vue&type=style&index=0&id=bf3fd1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3fd1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VImg,VRow})
